var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-box" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.info.passengerInfo,
            border: "",
            "max-height": "400px",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "乘客信息",
              align: "center",
              prop: "passengerInfo",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.userList.includes(row.passengerMobilePhone)
                      ? _c("yd-link", {
                          attrs: {
                            permi: "user_center_manage",
                            value: row.passengerInfo,
                            url: _vm.phoneUrl(
                              _vm.info,
                              row.passengerMobilePhone
                            ),
                            type: "userInfo",
                          },
                        })
                      : _c("span", [_vm._v(_vm._s(row.passengerInfo))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "证件", align: "center", prop: "idCard" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "座位号",
              align: "center",
              prop: "seatName",
              width: "60",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "车票状态",
              align: "center",
              prop: "ticketState",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "发票状态",
              align: "center",
              prop: "invoiceState",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "购票类型",
              align: "center",
              prop: "orderTicketType",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: row.childName
                            ? "乘车儿童姓名：" + row.childName
                            : row.passengerName,
                          placement: "right",
                        },
                      },
                      [_c("div", [_vm._v(_vm._s(row.orderTicketType))])]
                    ),
                    row.orderTicketType === "成人" && row.isEr
                      ? _c("div", [_vm._v("(儿童全价)")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "座位费",
              align: "center",
              prop: "seatAmount",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "支付金额",
              align: "center",
              prop: "payAmount",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "改签违约金",
              align: "center",
              prop: "changedPoundage",
              width: "60",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "退票违约金",
              align: "center",
              prop: "refundPoundage",
              width: "60",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "已退金额",
              align: "center",
              prop: "returnedAmount",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "剩余金额",
              align: "center",
              prop: "surplusAmount",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "退票时间", align: "center", prop: "refundTime" },
          }),
          _c("el-table-column", {
            attrs: { label: "退票入口", align: "center", prop: "refundEntry" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["order_intercity_resetTickt"],
                            expression: "['order_intercity_resetTickt']",
                          },
                        ],
                        attrs: {
                          type: "text",
                          size: "small",
                          loading: _vm.invoiceResetLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleReset(
                              scope.row.orderTicketId,
                              scope.row.invoiceStateCode
                            )
                          },
                        },
                      },
                      [_vm._v("\n          开票重置\n        ")]
                    ),
                    scope.row.ticketState === 4
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "right",
                                  width: "600",
                                  trigger: "click",
                                },
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.refundData,
                                      border: "",
                                      size: "mini",
                                      height: "220",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "编号",
                                        align: "center",
                                        prop: "ticketId",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "100",
                                        align: "center",
                                        label: "退款时间",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "100",
                                        align: "center",
                                        label: "退款金额（元）",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "100",
                                        align: "center",
                                        label: "退款类型",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "100",
                                        align: "center",
                                        label: "扣除手续费(元)",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "100",
                                        align: "center",
                                        label: "审核状态",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "100",
                                        align: "center",
                                        label: "操作人",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "name",
                                        align: "center",
                                        label: "备注",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }